import { trackProductTileProductClick } from "@faire/web-api/events/productTile/click/product";
import { IClickInfo } from "@faire/web-api/indigofair/data/IClickInfo";
import { ILeanProductTile } from "@faire/web-api/indigofair/data/ILeanProductTile";
import { useEffectEvent } from "@faire/web/ui/hooks/useEffectEvent";

import { getPromotedByString } from "@faire/retailer/hooks/ProductTileImpression/__internal__/getPromotedByString";
import { useProductTileClickImpressionContext } from "@faire/retailer/hooks/ProductTileImpression/useProductTileClickImpressionContext";
import { CATEGORY_PRODUCT_TRACK_CLICK_CONTAINER_NAME } from "@faire/retailer/services/consts";
import { trackProductClick } from "@faire/retailer/services/Events";

export const useRecordProductTileClickEvent = (
  productTile: ILeanProductTile | undefined,
  recordImpressions = false
) => {
  const { context, containerName, requestId, isNewProductsCategory } =
    useProductTileClickImpressionContext();

  return useEffectEvent(() => {
    const { product } = productTile ?? ILeanProductTile.build({});
    if (product?.token === undefined || !recordImpressions) {
      return;
    }

    const isMarketplaceProductTracking =
      containerName === CATEGORY_PRODUCT_TRACK_CLICK_CONTAINER_NAME;

    if (isMarketplaceProductTracking && containerName !== undefined) {
      const metadata: IClickInfo.IProductMetadata | undefined =
        product.is_promoted
          ? IClickInfo.IProductMetadata.build({
              promoted_by: product.promoted_by,
            })
          : undefined;
      trackProductClick(product.token, containerName, requestId, metadata);
    } else if (isNewProductsCategory) {
      trackProductClick(product.token, "new_product_tile", requestId);
    } else {
      trackProductClick(
        product.token,
        containerName ?? "product_marketplace_tile",
        requestId
      );
    }

    const promotedByString = getPromotedByString(product.promoted_by);
    trackProductTileProductClick(
      context,
      requestId ?? "",
      product.token,
      promotedByString,
      product.impression_id ?? ""
    );
  });
};
